module.exports = __webpack_public_path__ + "static/media/bing_logo_icon.b04de955.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bing_logo_icon.svg
// module id = 138
// module chunks = 0